import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagKG = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m37.226 25-4.995 2.35 2.66 4.838-5.425-1.038-.687 5.48L25 32.6l-3.779 4.03-.687-5.48-5.425 1.038 2.66-4.839L12.775 25l4.996-2.349-2.66-4.838 5.424 1.038.688-5.48L25 17.4l3.779-4.03.687 5.48 5.425-1.039-2.66 4.84L37.226 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 32.609a7.609 7.609 0 1 0 0-15.217 7.609 7.609 0 0 0 0 15.217Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M21.196 25a5.5 5.5 0 0 0-.543.027 4.329 4.329 0 0 0 1.017 2.768 7.626 7.626 0 0 1 1.47-2.434A5.407 5.407 0 0 0 21.197 25ZM23.538 29.095a4.338 4.338 0 0 0 2.925 0A5.436 5.436 0 0 0 25 26.56a5.437 5.437 0 0 0-1.462 2.536ZM28.765 22.827a4.345 4.345 0 0 0-7.53 0c1.37.007 2.656.38 3.765 1.023a7.557 7.557 0 0 1 3.765-1.023ZM26.86 25.361a7.623 7.623 0 0 1 1.47 2.434 4.329 4.329 0 0 0 1.017-2.768 5.404 5.404 0 0 0-2.488.334Z"
}));
FlagKG.displayName = 'FlagKG';
export default withFlagWrapper(FlagKG);
//# sourceMappingURL=index.js.map